Object.defineProperty(exports, '__esModule', {
  value: true
});
var isAfter = require('date-fns/isAfter');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var isAfter__default = /*#__PURE__*/_interopDefaultLegacy(isAfter);
var LessonStatus;
(function (LessonStatus) {
  LessonStatus["Active"] = "Active";
  LessonStatus["Pending"] = "Pending";
  LessonStatus["Cancelled"] = "Cancelled";
  LessonStatus["Deleted"] = "Deleted";
})(LessonStatus || (LessonStatus = {}));
var lessonStatusToString = function lessonStatusToString(lessonStatus, lessonDate) {
  switch (lessonStatus) {
    case LessonStatus.Active:
      return isAfter__default['default'](new Date(lessonDate), new Date()) ? "Upcoming" : "Completed";
    case LessonStatus.Cancelled:
      return "Cancelled";
    case LessonStatus.Pending:
      return "Upcoming";
    case LessonStatus.Deleted:
      return "Deleted";
  }
};
exports.default = lessonStatusToString;